import { render, staticRenderFns } from "./Step1CycloneInsurance.vue?vue&type=template&id=22c554ec&"
import script from "./Step1CycloneInsurance.vue?vue&type=script&lang=js&"
export * from "./Step1CycloneInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports